import { setThemes, initThemeControllers } from '@controllers/themeController.js';
import customNavbar from '@controllers/customNavbar.js';
import fairgroundsIndex from '@layouts/fairgroundsIndex';
import stateFairIndex from '@layouts/stateFairIndex.js';
import bbqFestIndex from './js/layouts/bbqFestIndex.js';
import oktoberfestIndex from './js/layouts/oktoberfestIndex.js';
import './js/localjs.js';

$(document).ready(() => {
  setThemes(themesData);
  fairgroundsIndex();
  stateFairIndex(themesData);
  bbqFestIndex(themesData);
  oktoberfestIndex(themesData);
  initThemeControllers();

  $(window).load(() => {
    customNavbar(themesData);
  });
});
